module.exports = __webpack_public_path__ + "img/Ecuador.f6ecb169.gif";